import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Icon from "storybookComponents/Icon"
import { styles } from "./style";
import DialogContent from '@material-ui/core/DialogContent';



const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});


const Popup = ({ classes, codeLink, title, children }) => {
  const [copied, setCopy] = React.useState(false);
  const [open, setOpen] = React.useState();

  const renderView = (code) => {
    return (
      <div className={`${classes.viewStyle}`}>{code}</div>
    )
  }

  const handleClick = () => {
    copyTextToClipboard(codeLink)
  }

  const toggle = () => {
    setOpen(!open)
  }

  const copyTextToClipboard = (text) => {
    setTimeout(() => {
      setCopy(false);
    }, 2000)
    navigator.clipboard.writeText(text).then(function () {
      setCopy(true)
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  return (
    <div>
      {typeof children === "function" ? children(toggle, copyTextToClipboard, copied) : children}
      <Dialog onClose={toggle} scroll="paper" className={classes.dialogStyle} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle className={classes.title} dividers onClose={toggle}>
          {title}
        </DialogTitle>
        <DialogContent className={classes.body}>
          {renderView(codeLink)}
        </DialogContent>
        <div className={classes.actions}>
          <div className={copied ? classes.copiedButton : classes.buttonClass} onClick={handleClick}>
            {copied && <Icon className={classes.iconWeight} type="icon-check-single" size="xs" />}
            {copied ? "Copied" : "Copy"}
          </div>
        </div>
      </Dialog>
    </div>
  );
}


export default withStyles(styles)(Popup);